import React, { Component } from 'react';
import axios from 'axios';
import ScrollupSection from '../components/scrollupSection/scrollUp';
import Header from '../components/welcomeSection/header';
import { Link, withRouter } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';

class CheckoutConfirmation extends Component {
    state = {
        transactionStatus: 'PENDING',
        isLoading: true,
        numbers: [],
        dni: null,
        password: null,
        privilegedNumbers: [],
        maxDigits: 5,
    }

    async componentDidMount() {
        const params = new URLSearchParams(window.location.search);
        const clientTransactionId = params.get('clientTransactionId');
        const id = params.get('id');

        if (!clientTransactionId || !id) {
            this.goToIndex();
            return;
        }

        try {
            const response = await axios.get('https://api.proyectoshark.com/games/public/purchase/status', {
                params: {
                    clientTransactionId,
                    id,
                },
            });

            if (response.status === 200) {
                this.setState({
                    transactionStatus: response.data.status,
                    numbers: response.data.numbers || [],
                    dni: response.data.dni,
                    password: response.data.password,
                    privilegedNumbers: response.data.privileged_numbers || [],
                    isLoading: false,
                    maxDigits: response.data.max_digits || 5,
                });

                const eventId1 = uuidv4();
                const eventId2 = uuidv4();
                const eventName1 = 'Purchase';
                const eventName2 = 'PurchaseByCreditCard';
                if (window.fbq) {
                    window.fbq('track', eventName1, {}, { eventID: eventId1 });
                    window.fbq('trackCustom', eventName2, {}, { eventID: eventId2 });
                }

                axios.post('https://api.proyectoshark.com/games/public/tracking/event', {
                    eventName: eventName1,
                    eventId: eventId1,
                    value: response.data.total || 0,
                })
                    .then(res => {
                        console.log(`Event ${eventName1} sent successfully:`, res.data);
                    })
                    .catch(err => {
                        console.log(err)
                    })

                axios.post('https://api.proyectoshark.com/games/public/tracking/event', {
                    eventName: eventName2,
                    eventId: eventId2,
                    value: response.data.total || 0,
                })
                    .then(res => {
                        console.log(`Event ${eventName2} sent successfully:`, res.data);
                    })
                    .catch(err => {
                        console.log(err)
                    })
            } else {
                console.warn('Internal server error', response.status);
                this.goToIndex();
            }
        } catch (error) {
            console.error('Error en la verificación de compra:', error);
            this.goToIndex();
        }
    }

    goToIndex = () => {
        this.props.history.push('/')
    }

    render() {
        const { isLoading, transactionStatus, numbers, dni, password, privilegedNumbers, maxDigits } = this.state;

        let content;
        if (isLoading) {
            content = (
                <div className="text-center">
                    <h2>Cargando...</h2>
                    <p>Estamos verificando tu transacción</p>
                </div>
            );
        } else if (transactionStatus === 'APPROVED') {
            content = (
                <div className="text-center">
                    <h2>¡Gracias por tu compra!</h2>
                    <p>Hemos recibido tu pago correctamente.</p>
                </div>
            );
        } else {
            content = (
                <div className="text-center">
                    <h2>Pago cancelado</h2>
                    <p>No se completó el proceso de pago.</p>

                    <Link to="/">
                        <button className="buy-btn mt-3">Volver al inicio</button>
                    </Link>
                </div>
            );
        }

        return (
            <div className="miami">
                <ScrollupSection />
                <div className="all-area">
                    <Header />
                    <section className="section about-app-area ptb_50">
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-md-6">
                                    {content}
                                </div>
                            </div>

                            {numbers.length > 0 && (
                                <div className="row justify-content-center mt-4">
                                    <div className="col-12">
                                        <div className="text-center mt-4">
                                            <h3>Tus números</h3>
                                            <div className="ticket-container">
                                                {numbers.map((number, index) => (
                                                    <div className="ticket" key={index}>
                                                        <div className="line" />
                                                        <div className="number">{number.toString().padStart(maxDigits, '0')}</div>
                                                        <div className="line" />
                                                    </div>
                                                ))}
                                            </div>
                                        </div>

                                    </div>
                                    {privilegedNumbers.length > 0 && (
                                        <div className="col-12 mt-5">
                                            <p>
                                                Recuerda revisar si tienes uno de estos {privilegedNumbers.length} números shark favorecidos con premios en efectivo:
                                            </p>
                                            <div className="text-center mt-4">
                                                <ul style={{ listStyle: 'disc', paddingLeft: '20px', fontSize: '18px' }}>
                                                    {privilegedNumbers.map((number, index) => (
                                                        <li key={index} style={{ padding: '5px' }}>
                                                            {number.toString().padStart(maxDigits, '0')}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    )}

                                    {password && (
                                        <div className="col-12 mt-5">
                                            <p>
                                                Tambien puedes revisar en cualquier momento tus numeros ingresando a <a href="https://app.proyectoshark.com" target="_blank" rel="noopener noreferrer">
                                                    app.proyectoshark.com
                                                </a> con tu cedula: <strong>{dni}</strong> y contraseña: <strong>{password}</strong>.
                                            </p>
                                        </div>
                                    )}
                                </div>
                            )}

                            <div className="row justify-content-center">
                                <div className="col-md-6">
                                    {isLoading === false && <Link to="/">
                                        <button className="buy-btn mt-3">Volver al inicio</button>
                                    </Link>}
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        );
    }
}

export default withRouter(CheckoutConfirmation);
